export const DEALER_CALLS = {
    "partner-contact-form" : {
        "use_mock": false,
        "mock_endpoint": "motorcycles/dealer-inquiry",
        "api_type": "POST",
        "requires_auth" : false
    }
}